'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    NumberField: ()=>NumberField
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const number_field_namespaceObject = require("@base-ui-components/react/number-field");
const react_namespaceObject = require("motion/react");
const index_cjs_namespaceObject = require("../Button/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_NumberField_variants_cjs_namespaceObject = require("./NumberField.variants.cjs");
const external_NumberFieldButton_cjs_namespaceObject = require("./NumberFieldButton.cjs");
function NumberField({ iconButtonType = 'primary', defaultValue, emphasis = 'regular', inputType = 'box', min = 0, max = 10, cta = false, step = 1, disabled, handleValueChange, size = 'sm', id, ctaButtonProps = {}, incrementIconButtonProps, decrementIconButtonProps, decrementIconTooltipProps, incrementIconTooltipProps, shouldAnimate = false, ...props }) {
    const initValue = defaultValue ?? min;
    const [val, setVal] = (0, external_react_namespaceObject.useState)(initValue);
    const [displayCta, setDisplayCta] = (0, external_react_namespaceObject.useState)(cta && 0 === initValue);
    const [stage, setStage] = (0, external_react_namespaceObject.useState)(0);
    const [animationDirection, setAnimationDirection] = (0, external_react_namespaceObject.useState)('forward');
    const resolvedAnimationInitial = (0, external_react_namespaceObject.useMemo)(()=>'forward' == animationDirection ? {
            x: '100%',
            opacity: 1
        } : {
            x: '60%',
            opacity: 1
        }, [
        animationDirection
    ]);
    const onValueChange = (0, external_react_namespaceObject.useCallback)((value)=>{
        if (null === value || value === val) return;
        setVal(value);
        handleValueChange(value);
        value === min && cta ? setDisplayCta(true) : setDisplayCta(false);
    }, [
        val,
        min,
        cta,
        handleValueChange
    ]);
    const hideCta = (0, external_react_namespaceObject.useCallback)(()=>{
        setVal((prev)=>prev + step);
        setDisplayCta(false);
        if (shouldAnimate) {
            setAnimationDirection('forward');
            setStage(1);
        }
    }, [
        step,
        shouldAnimate
    ]);
    const handleDecrementClick = (0, external_react_namespaceObject.useCallback)(()=>{
        if (0 === val) {
            setAnimationDirection('backward');
            setStage(0);
        }
    }, [
        val
    ]);
    const { group, numericInput, ctaButton } = (0, external_NumberField_variants_cjs_namespaceObject.numberFieldVariants)({
        emphasis,
        inputType,
        size
    });
    const inputClasses = (0, external_utils_index_cjs_namespaceObject.cn)(numericInput());
    const addButtonType = external_NumberField_variants_cjs_namespaceObject.numberFieldIconButtonVariants[iconButtonType].add;
    const removeButtonType = external_NumberField_variants_cjs_namespaceObject.numberFieldIconButtonVariants[iconButtonType].remove;
    const { size: ctaSize = 'sm', children: ctaChildren = 'Add', iconLeft = 'add', ...restProps } = ctaButtonProps;
    const renderCtaButton = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
            "data-testid": "number-field-cta-button",
            size: ctaSize,
            onClick: hideCta,
            type: iconButtonType,
            iconLeft: iconLeft,
            emphasis: emphasis,
            disabled: disabled,
            className: ctaButton(),
            ...restProps,
            children: ctaChildren
        });
    const renderNumberField = (showDecrementButton = true)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(number_field_namespaceObject.NumberField.Root, {
            id: id,
            min: min,
            max: max,
            onValueChange: onValueChange,
            allowWheelScrub: false,
            value: val,
            step: step,
            disabled: disabled,
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": val,
            ...props,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(number_field_namespaceObject.NumberField.Group, {
                className: group(),
                children: [
                    showDecrementButton ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_NumberFieldButton_cjs_namespaceObject.NumberFieldButton, {
                        type: "decrement",
                        iconButtonProps: {
                            ...decrementIconButtonProps,
                            onClick: (event)=>{
                                event.stopPropagation();
                                handleDecrementClick();
                                decrementIconButtonProps?.onClick?.(event);
                            }
                        },
                        emphasis: emphasis,
                        disabled: disabled || val === min,
                        buttonType: removeButtonType,
                        tooltipProps: decrementIconTooltipProps
                    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: "invisible",
                        style: {
                            width: 'var(--number-field-button-width, 40px)'
                        },
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(number_field_namespaceObject.NumberField.Input, {
                        className: inputClasses,
                        "data-testid": "number-field-input"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_NumberFieldButton_cjs_namespaceObject.NumberFieldButton, {
                        type: "increment",
                        iconButtonProps: incrementIconButtonProps,
                        emphasis: emphasis,
                        disabled: disabled || val === max,
                        buttonType: addButtonType,
                        tooltipProps: incrementIconTooltipProps
                    })
                ]
            })
        });
    if (shouldAnimate && cta) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "rounded-action-sm relative w-[128px] overflow-hidden leading-[32px]",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(react_namespaceObject.AnimatePresence, {
                mode: "sync",
                children: [
                    0 === stage ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.div, {
                        initial: resolvedAnimationInitial,
                        animate: {
                            x: 0,
                            opacity: 1
                        },
                        exit: {
                            x: '100%',
                            opacity: 1
                        },
                        transition: {
                            x: {
                                duration: 0.3,
                                ease: 'easeInOut'
                            },
                            opacity: {
                                duration: 0.15,
                                ease: 'easeOut'
                            }
                        },
                        className: "z-11 absolute inset-0",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
                            "data-testid": "number-field-cta-button",
                            size: ctaSize,
                            children: ctaChildren,
                            onClick: hideCta,
                            type: iconButtonType,
                            iconLeft: iconLeft,
                            emphasis: emphasis,
                            disabled: disabled,
                            className: `${ctaButton()}`,
                            ...restProps
                        })
                    }, `stage-0-${animationDirection}`) : null,
                    1 === stage ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.div, {
                        initial: resolvedAnimationInitial,
                        animate: {
                            x: 0,
                            opacity: 1
                        },
                        exit: {
                            x: '100%',
                            opacity: 1
                        },
                        transition: {
                            x: {
                                duration: 0.3,
                                ease: 'easeInOut'
                            },
                            opacity: {
                                duration: 0.15,
                                ease: 'easeOut'
                            }
                        },
                        className: "absolute inset-0 z-10",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(number_field_namespaceObject.NumberField.Root, {
                            id: id,
                            min: min,
                            max: max,
                            onValueChange: onValueChange,
                            allowWheelScrub: false,
                            value: val,
                            step: step,
                            disabled: disabled,
                            "aria-valuemin": min,
                            "aria-valuemax": max,
                            "aria-valuenow": val,
                            ...props,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(number_field_namespaceObject.NumberField.Group, {
                                className: group(),
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_NumberFieldButton_cjs_namespaceObject.NumberFieldButton, {
                                        type: "decrement",
                                        iconButtonProps: {
                                            ...decrementIconButtonProps,
                                            onClick: (event)=>{
                                                event.stopPropagation();
                                                handleDecrementClick();
                                                decrementIconButtonProps?.onClick?.(event);
                                            }
                                        },
                                        emphasis: emphasis,
                                        buttonType: removeButtonType,
                                        tooltipProps: decrementIconTooltipProps
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(number_field_namespaceObject.NumberField.Input, {
                                        className: inputClasses,
                                        "data-testid": "number-field-input"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_NumberFieldButton_cjs_namespaceObject.NumberFieldButton, {
                                        type: "increment",
                                        iconButtonProps: incrementIconButtonProps,
                                        emphasis: emphasis,
                                        disabled: disabled || val === max,
                                        buttonType: addButtonType,
                                        tooltipProps: incrementIconTooltipProps
                                    })
                                ]
                            })
                        })
                    }, "stage-2") : null
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: 'w-10 text-transparent',
                children: "."
            })
        ]
    });
    return displayCta ? renderCtaButton() : renderNumberField();
}
exports.NumberField = __webpack_exports__.NumberField;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "NumberField"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
